import { get } from 'lodash-es';
import { pageDefinition } from 'site-modules/shared/pages/page';
import { getBreadcrumbSchema } from 'client/seo/schemas/breadcrumbs';
import { getHomeBreadcrumb } from 'site-modules/shared/components/breadcrumbs/helper';
import { ABOUT_BREADCRUMB } from 'client/site-modules/editorial/constants/about';
import { ORGANIZATION_JSON_LD_OBJECT } from 'site-modules/shared/pages/seo';
import { EdmundsCpaNoAdhesionDecorator } from 'site-modules/shared/pages/decorators/edmunds-cpa-no-adhesion';
import { About } from './index';

const pageDefinitionConfiguration = {
  name: 'other_about_us_index',
  category: 'other_about_us_index',
  seo: state => {
    const addOrganizationOnlyToAboutPage = get(state, 'featureFlags["enable-seot-3616-move-org-schema"]');
    const jsonld = addOrganizationOnlyToAboutPage
      ? [ORGANIZATION_JSON_LD_OBJECT, getBreadcrumbSchema([getHomeBreadcrumb(), ABOUT_BREADCRUMB])]
      : [getBreadcrumbSchema([getHomeBreadcrumb(), ABOUT_BREADCRUMB])];
    return {
      title: 'About Us | Edmunds',
      description:
        "Find out more about Edmunds.com on our About Us page. You can also read about our 'Secret Sauce', view job openings, submit feedback, and much more!",
      keywords: 'About Us, About Edmunds, Edmunds.com, The Car People, Secret Sauce, Edmunds Careers, Jobs at Edmunds',
      canonical: 'https://www.edmunds.com/about/',
      jsonld,
    };
  },
  component: About,
  decorator: EdmundsCpaNoAdhesionDecorator,
};

export default pageDefinition(pageDefinitionConfiguration);
